export enum FontSize {
    Tiny    = 0,
    Small   = 1,
    Normal  = 2,
    Large   = 3,
    Huge    = 4
}
